import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import {
    Template,
    LandingPage,
    SMS,
    VoiceContent,
    ContentType,
    ContentTypeEnumForBackend,
} from 'domains/content/types';
import { Folder } from 'models/types';

type ArchivedContent = Template | LandingPage | SMS | VoiceContent | Folder;

type UseArchivedContentListParams = {
    type?: string;
    searchTerm?: string;
    statuses?: string[];
    reactQueryOptions?: UseQueryOptions<ArchivedContent[], Error>;
};

const useArchivedContentList = ({
    type,
    searchTerm,
    statuses,
    reactQueryOptions,
}: UseArchivedContentListParams = {}) => {
    let apiType = type;
    if (type === ContentType.PAGE) {
        apiType = ContentTypeEnumForBackend['Landing Page'] as string;
    }

    const params: Record<string, string> = {};
    if (type) {
        params.type = apiType;
    }
    if (searchTerm) {
        params.searchTerm = searchTerm;
    }
    if (statuses && statuses.length > 0) {
        params.status = statuses.join(',');
    }

    const axiosOptions = Object.keys(params).length > 0 ? { params } : {};

    return useQuery(
        [QueryKeys.ARCHIVED_CONTENT, type, searchTerm, statuses?.join(',')],
        CuredApiPaths.CONTENT_ARCHIVED_LIST,
        reactQueryOptions,
        axiosOptions
    );
};

export default useArchivedContentList;
